var render = function render(){var _vm=this,_c=_vm._self._c;return _c('top-bar-menu',{attrs:{"title":_vm.userName,"links":_vm.links,"without-sort":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }